import { EntityType } from '@repo/common/enums/entityType';

export const validateEntityType = (
	type: string | null | undefined
): EntityType => {
	if (!type || !(type in EntityType)) {
		return EntityType.all; // Default fallback
	}
	return type as EntityType;
};
